import React from 'react';
import withNavigate from '../../../core/withNavigate';
import { ShelfStoreCheckProfile } from '../../../components/storecheck/storecheck';
import { InventoryTable } from '../../../components/stores/store/elements';
import { expirationColumn } from '../elements';
import MIMESA_CONFIG from '../config';

/**
 * Mimesa's store check detail: the base page plus the visit's warehouse inventory with each
 * product's expiration date ("Vencimiento"), captured in the app's inventory step.
 */
export class MimesaStoreCheckProfile extends ShelfStoreCheckProfile {
    renderInventory(storeCheck) {
        const inventory = storeCheck?.inventory;
        if (!Array.isArray(inventory) || inventory.length === 0) return null;
        return <InventoryTable inventory={inventory} loading={this.state.elementsLoading} extraColumns={[expirationColumn(MIMESA_CONFIG.expiryWarningDays)]} />;
    }
}

export default withNavigate(MimesaStoreCheckProfile);
